import {NonIndexRouteObject} from "react-router"
import {SeaApp} from "../components/app/SeaApp";
import {ErrorPage} from "../components/page";
import {navigationStore, pageQueryStore, seaDocumentListStore} from "../store";
import {DocumentTypeDto, ScanDocumentSortByDto, ScanStatusDto, SortTypeDto} from "../api/sea";


const sea:NonIndexRouteObject[] = [
    {
        path: `/sea/document`,
        element: <SeaApp type={'document'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            const searchParams = new URL(request.url).searchParams
            pageQueryStore.updateSystem('sea', searchParams)
            seaDocumentListStore.page = parseInt(searchParams.get("page") || "") || 1
            seaDocumentListStore.size = parseInt(searchParams.get("size") || "") || 25
            seaDocumentListStore.query = searchParams.get('q') || undefined
            seaDocumentListStore.type = searchParams.getAll('type').map(e => e as DocumentTypeDto) || undefined
            seaDocumentListStore.status = searchParams.getAll('status').map(e => e as ScanStatusDto) || undefined
            seaDocumentListStore.sortType = searchParams.get('sortType') as SortTypeDto || undefined
            seaDocumentListStore.sortBy = searchParams.get('sortBy') as ScanDocumentSortByDto || undefined

            seaDocumentListStore.fromAbsolute = searchParams.get('fromAbsolute') || undefined
            seaDocumentListStore.fromRelative = searchParams.get('fromRelative') || undefined
            seaDocumentListStore.toAbsolute = searchParams.get('toAbsolute') || undefined
            seaDocumentListStore.toRelative = searchParams.get('toRelative') || undefined

            await seaDocumentListStore.load()
            navigationStore.setActivePath(request)
            return null
        }
    }
]

export {
    sea
}
